import { Card, Col, Row } from "react-bootstrap"

export default function ExternalSystemsDashboardCards({externalSystems}) {

    return (

        <Row className="mb-4">

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h6>Aplicações Ativas</h6>
                        <h3>{externalSystems.filter(item => item.status == 1).length}</h3>
                    </Card.Body>
                </Card>
            </Col>

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h6>Aplicações Inativas</h6>
                        <h3>{externalSystems.filter(item => item.status == 0).length}</h3>
                    </Card.Body>
                </Card>
            </Col>

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h6>Soluções Sob Medida</h6>
                        <h3>{externalSystems.filter(item => item.custom == 1).length}</h3>
                    </Card.Body>
                </Card>
            </Col>

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h6>Soluções de Uso Geral</h6>
                        <h3>{externalSystems.filter(item => item.custom == 0).length}</h3>
                    </Card.Body>
                </Card>
            </Col>

        </Row>

    )

}
